/**
 * Формат ресурса (отчета, печатной формы, и т.п).
 */
export enum ResourceFormat {
    PDF = 'PDF',

    TXT = 'TXT',

    ZIP = 'ZIP',
}
